import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_HI: MRT_Localization = {
  language: "hi",
  actions: "क्रियाएं",
  and: "और",
  cancel: "रद्द करें",
  changeFilterMode: "फ़िल्टर मोड बदलें",
  changeSearchMode: "खोज मोड बदलें",
  clearFilter: "फ़िल्टर साफ़ करें",
  clearSearch: "खोज साफ़ करें",
  clearSelection: "चयन साफ़ करें",
  clearSort: "क्रम साफ़ करें",
  clickToCopy: "कॉपी करने के लिए क्लिक करें",
  copy: "कॉपी करें",
  collapse: "संकुचित करें",
  collapseAll: "सभी को संकुचित करें",
  columnActions: "कॉलम क्रियाएं",
  copiedToClipboard: "क्लिपबोर्ड में कॉपी किया गया",
  dropToGroupBy: "समूह बनाने के लिए {column} पर ड्रॉप करें",
  edit: "संपादित करें",
  expand: "विस्तृत करें",
  expandAll: "सभी को विस्तृत करें",
  filterArrIncludes: "शामिल करता है",
  filterArrIncludesAll: "सभी शामिल करता है",
  filterArrIncludesSome: "शामिल करता है",
  filterBetween: "बीच में",
  filterBetweenInclusive: "समावेशी बीच में",
  filterByColumn: "{column} द्वारा फ़िल्टर करें",
  filterContains: "शामिल करता है",
  filterEmpty: "खाली",
  filterEndsWith: "के साथ समाप्त होता है",
  filterEquals: "बराबर",
  filterEqualsString: "बराबर",
  filterFuzzy: "फज़ी",
  filterGreaterThan: "से बड़ा",
  filterGreaterThanOrEqualTo: "से बड़ा या बराबर",
  filterInNumberRange: "बीच में",
  filterIncludesString: "शामिल करता है",
  filterIncludesStringSensitive: "शामिल करता है",
  filterLessThan: "से छोटा",
  filterLessThanOrEqualTo: "से छोटा या बराबर",
  filterMode: "फ़िल्टर मोड: {filterType}",
  filterNotEmpty: "खाली नहीं",
  filterNotEquals: "बराबर नहीं",
  filterStartsWith: "के साथ शुरू होता है",
  filterWeakEquals: "बराबर",
  filteringByColumn: "{column} द्वारा फ़िल्टरिंग - {filterType} {filterValue}",
  goToFirstPage: "पहले पेज पर जाएं",
  goToLastPage: "अंतिम पेज पर जाएं",
  goToNextPage: "अगले पेज पर जाएं",
  goToPreviousPage: "पिछले पेज पर जाएं",
  grab: "पकड़ें",
  groupByColumn: "{column} द्वारा समूह बनाएं",
  groupedBy: "द्वारा समूहीकृत ",
  hideAll: "सभी को छुपाएं",
  hideColumn: "{column} कॉलम छुपाएं",
  max: "अधिकतम",
  min: "न्यूनतम",
  move: "स्थानांतरित करें",
  noRecordsToDisplay: "दिखाने के लिए कोई रिकॉर्ड नहीं",
  noResultsFound: "कोई परिणाम नहीं मिला",
  of: "का",
  or: "या",
  pin: "पिन करें",
  pinToLeft: "बाएं पिन करें",
  pinToRight: "दाएं पिन करें",
  resetColumnSize: "कॉलम आकार रीसेट करें",
  resetOrder: "क्रम रीसेट करें",
  rowActions: "पंक्ति क्रियाएं",
  rowNumber: "#",
  rowNumbers: "पंक्ति संख्याएं",
  rowsPerPage: "प्रति पेज पंक्तियां",
  save: "सहेजें",
  search: "खोजें",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} में से {rowCount} पंक्ति(यां) चयनित",
  select: "चयन करें",
  showAll: "सभी दिखाएं",
  showAllColumns: "सभी कॉलम दिखाएं",
  showHideColumns: "कॉलम दिखाएं/छुपाएं",
  showHideFilters: "फ़िल्टर दिखाएं/छुपाएं",
  showHideSearch: "खोज दिखाएं/छुपाएं",
  sortByColumnAsc: "{column} द्वारा आरोही क्रम में सॉर्ट करें",
  sortByColumnDesc: "{column} द्वारा अवरोही क्रम में सॉर्ट करें",
  sortedByColumnAsc: "{column} द्वारा आरोही क्रम में सॉर्ट किया गया",
  sortedByColumnDesc: "{column} द्वारा अवरोही क्रम में सॉर्ट किया गया",
  thenBy: ", फिर ",
  toggleDensity: "घनत्व टॉगल करें",
  toggleFullScreen: "पूर्ण स्क्रीन टॉगल करें",
  toggleSelectAll: "सभी चयन टॉगल करें",
  toggleSelectRow: "पंक्ति चयन टॉगल करें",
  toggleVisibility: "दृश्यता टॉगल करें",
  ungroupByColumn: "{column} द्वारा समूह हटाएं",
  unpin: "अनपिन करें",
  unpinAll: "सभी अनपिन करें",
};
